module.exports = __webpack_public_path__ + "static/img/Yummy-Recipe.a5c0378.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/funplus/imgs/browse/Yummy-Recipe.jpg
// module id = 1956
// module chunks = 0